import { Component } from '@angular/core';

import { SkyModalInstance } from '../../core';

import { SkyModalDemoContext } from './modal-demo-context';


export class SkyModalDemoTiledFormComponent {
  public title = 'Hello world';

  constructor(
    public context: SkyModalDemoContext,
    public instance: SkyModalInstance
  ) { }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-demo-modal-tiled-form',
  template: `<sky-modal [tiledBody]="true">
  <sky-modal-header>
    {{title}}
  </sky-modal-header>
  <sky-modal-content>
    <sky-tile>
      <sky-tile-title>Section 1</sky-tile-title>
      <sky-tile-content>
        <sky-tile-content-section>
          Content 1
        </sky-tile-content-section>
      </sky-tile-content>
    </sky-tile>
    <sky-tile>
      <sky-tile-title>Section 2</sky-tile-title>
      <sky-tile-content>
        <sky-tile-content-section>
          Content 2
        </sky-tile-content-section>
      </sky-tile-content>
    </sky-tile>
  </sky-modal-content>
  <sky-modal-footer>
    <button
      type="button"
      class="sky-btn sky-btn-primary"
      (click)="instance.save('Something cool')"
    >
      Close
    </button>
  </sky-modal-footer>
</sky-modal>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyModalDemoContext, },
{type: SkyModalInstance, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
